import React from 'react'
import './css/Materials.css'
import {Link} from "react-router-dom";
import {Layout} from "antd";
import HeaderNav from "../header/header";
const { Content } = Layout;

class Faq extends React.Component{
    render() {
        return <div>
            <HeaderNav parmas={'/faq'}/>
            <Layout className="site-layout-background" style={{ padding: '24px 0',width: '1000px',margin: '0 auto'  }}>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    <h1>Frequently Asked Questions</h1>
                    <ul className="list-box">
                        <li>
                            <strong>How to proceed if the spin icon hang on and there is no further response in the dispute submission page?</strong>
                            <em>Normally it's because of the big uploading attachment, please try to edit/compress the uploading picture/files under 10MB (every single file under10MB, overall under 100MB for the whole dispute).</em>
                        </li>
                        <li>
                            <strong>What is a Sold To number and where can I find it?</strong>
                            <em>The Sold To is a unique number assigned to the customer and it is possible to find it on the invoice's top left corner, next to the invoice date.</em>
                        </li>
                        <li>
                            <strong>I have received goods despite the fact, that I have cancelled the order.</strong>
                            <em>Please, click <Link to='/'>here</Link> and submit your claim. Please, include also a written confirmation of the cancellation of your order.</em>
                        </li>
                        <li>
                            <strong>I was invoiced a higher price, despite the fact, that I have ordered against a valid special bid (SBO).</strong>
                            <em>Please, click <Link to='/'>here</Link> and submit your claim. Please, include also a copy of the special bid (SBO).</em>
                        </li>
                        <li>
                            <strong>The invoice is not correct. The invoice address / purchase order # / VAT ID is not correct.</strong>
                            <em> Please, click <Link to='/'>here</Link> and submit your claim. Please, include also a written confirmation of the correct invoice address / the purchase order # / the correct VAT ID.</em>
                        </li>
                        <li>
                            <strong>The quantity of received goods differs from the invoiced quantity.</strong>
                            <em> Please, click <Link to='/'>here</Link> and submit your claim. Please, include also a copy of your order. In case goods are missing, check order visibility portal and include POD.</em>
                        </li>
                        <li>
                            <strong>We have received a different product from that which we ordered.</strong>
                            <em> Please, click <Link to='/'>here</Link> and submit your claim. Please, include also pictures of label of the received product and a copy of your order.</em>
                        </li>
                        <li>
                            <strong>What is a RMA / SO?</strong>
                            <em> It is the returns reference which we use to identify your returns request. Our carrier will be referencing to this number when contacting you regarding the return. The number looks like this: 422xxxxxx</em>
                        </li>
                        <li>
                            <strong>Who and when will pick-up the goods which I want to return?</strong>
                            <em> The returns process is being managed by our contractor. They will contact you via e-mail or phone and arrange the details of the collection (date and time). They will be referencig to the RMA / SO (see question „What is a RMA / SO?“). Your cooperation with our carrier will be highly appreciated and will help to process the returns request as soon and smoothly as possible.</em>
                        </li>
                        <li>
                            <strong>There is no physical damage of the product, however the product is not working.</strong>
                            <em> Please, contact the Helpline.</em>
                        </li>
                    </ul>
                </Content>
            </Layout>
        </div>

    }
}

export default Faq;